import React from "react";
import PickUp from "../../Assets/Images/pickup.png";
import Washing from "../../Assets/Images/washing.png";
import Delivery from "../../Assets/Images/delivery.png";
import Moment from "react-moment";

const LaundryOrderCard = ({ setLaundryOrders, setSelectedOrder, item }) => {
  // const LaundryTypeArray = item.laundry_type?.map((one, idx) => {
  //   console.log(one);
  // })
  return (
    <div
      onClick={() => {
        setLaundryOrders(true);
        setSelectedOrder(item);
      }}
      className="col-12 historydetails hd"
    >
      <div className="col-xsm-4">
        <div>
          <p>{item.order_id}</p>
          <p>
            <span>
              <Moment format="HH:mm">{item.created_at}</Moment> |{" "}
            </span>
            <span>
              <Moment format="YYYY/MM">{item.created_at}</Moment>
            </span>
          </p>
        </div>
      </div>
      <div className="col-xsm-6">
        <div>
          {item?.laundry_type?.map((one, idx) => (
            <>
              <p>{one.cloth_type} ({one.service_type} & {one.extra})</p>
              {/* <p>{one.cloth_count} items </p> */}
            </>
          ))}
          <p>
            {/* <span>Pickup: {item.pick_up}</span> */}
            <span>
              <span className="fw-bold">Delivery:{" "}</span>
              {item.delivery === "onsite" ? "On site" : item.delivery_address}
            </span>
          </p>
        </div>
      </div>
      <div className="col-xsprice ">
        <p>₦{item.total_price}</p>
      </div>
      <div className="col-xsm-12">
        <span className={item.status === 0 ? "opacity-25" : "opacity-100"}>
          <img alt="" src={PickUp} />
          <span className="hr-sepe"></span>
        </span>

        <span
          className={
            item.status === 0
              ? "opacity-25"
              : item.status === 1
              ? "opacity-100"
              : ""
          }
        >
          <img alt="" src={Washing} />
          <span className="hr-sepe"></span>
        </span>
        <span
          className={
            item.status === 1
              ? "opacity-25"
              : item.status === 2
              ? "opacity-25"
              : item.status === 3
              ? "opacity-100"
              : ""
          }
        >
          <img alt="" src={Delivery} />
        </span>
      </div>
    </div>
  );
};

export default LaundryOrderCard;
